/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable require-await */
/* eslint-disable no-nested-ternary */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable consistent-return */
/* eslint-disable react/no-array-index-key */
/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable @typescript-eslint/no-use-before-define */

import MUISelectInput from '@brands/Components/Inputs/MuiSelectInput/MUISelectInput';
import { Loading } from '@brands/Components/LoadingSpinner/Loading';
import PatientIntakeNavigation from '@brands/Components/PatientIntakeNavigation/PatientIntakeNavigation';
import { config } from '@brands/config/config';
import StateModal from '@brands/Dashboard/Dashboard/DashboardModals/StateModal/StateModal';
import SubmitCCConfirmationModal from '@brands/Dashboard/Dashboard/DashboardModals/SubmitCCConfirmationModal';
import { useOrganizationFlags, useWindowSize } from '@brands/hooks';
import { useAppSelector } from '@brands/hooks/useReduxHook';
import useRoleNavigate from '@brands/hooks/useRoleNavigate';
import { useSnackbar } from '@brands/hooks/useStackbar';
import { CasePayload, createNewCase } from '@brands/services/cases/createNewCase';
import { CaseType } from '@brands/services/cases/types/ICase';
import { deactivateInsuranceById } from '@brands/services/identity/deactivatePatientInsurance';
import { getPricings, Pricings } from '@brands/services/identity/getPricings';
import { getUserAvatar } from '@brands/services/identity/getUserAvatar';
import { listDependents } from '@brands/services/identity/listDependents';
import { Organization } from '@brands/services/identity/types/UserProfile';
import { selectAuth } from '@brands/store/selectors/auth';
import { selectCurrentPatientState } from '@brands/store/selectors/currentPatientState';
import { selectLinkedCase } from '@brands/store/selectors/linkedCase';
import { clearLinkedCase } from '@brands/store/slices/linkedCaseSlice';
import { selectShowStateModal } from '@brands/store/selectors/location';
import { selectOrganization } from '@brands/store/selectors/organization';
import { selectOrganizationPrices } from '@brands/store/selectors/organizationPrices';
import { selectPatientForm } from '@brands/store/selectors/patientForm';
import { setPatientState } from '@brands/store/slices/currentPatientState';
import { setShowStateModal } from '@brands/store/slices/location';
import { setOrganizationPrices } from '@brands/store/slices/organizationPricingSlice';
import { clearPageState, setDependentId, setIsFromSelectPatient } from '@brands/store/slices/pageStateSlice';
import { FormValues, setExternalForms, setForm, setSelectedPatient } from '@brands/store/slices/patientFormSlice';
import { setSelectedPatientByAdmin } from '@brands/store/slices/selectedPatientSlice';
import { setCaseId } from '@brands/store/slices/smileScanCaseSlice';
import { checkExternalFormAnswers } from '@brands/Utils/checkExternalForms';
import { displayErrorDetails } from '@brands/Utils/displayError';
import GenericSnackbar from '@brands/Utils/GenericSnackbar';
import { getCurrentPState, setCurrentPatientState as setCurrentPatientLocationState } from '@brands/Utils/localStorage';
import { isFree, needsPayment } from '@brands/Utils/needsPayment';
import { stateOptionsWithoutAbbreviation } from '@brands/Utils/selectOptions';
import AddIcon from '@mui/icons-material/Add';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { Button } from '@mui/material';
import React, { Fragment, useCallback, useEffect, useMemo, useState } from 'react';
import { isMobile as mobileDetect } from 'react-device-detect';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';

import Container from '../../../../Components/Container/Container';
import InsuranceVerifyModal from './Components/InsuranceVerifyModal';
import NoServiceAvailableModal from './Components/NoServiceAvailableModal';
import styles from './styles.module.scss';
import { SelectPatientForm, UserObject } from './utils/types';
import { selectIsFromHandOff } from '@brands/store/selectors/isFromHandOff';
import { completeMobileHandoff } from '@brands/services/communication/completeMobileHandover';
import { setIsFromHandoff } from '@brands/store/slices/isFromHandOffSlice';
import { uploadMediaToCase } from '@brands/Dashboard/MyProfile/Patient/utils/utilsFunctions';

const SelectPatient = (): JSX.Element => {
  const screenSize = useWindowSize();
  const { values, isFromSmileScanReport } = useAppSelector(selectPatientForm);
  const isMobile = screenSize.width < 768;
  const { snackbar, closeSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const roleNavigate = useRoleNavigate();
  const showStateModal = useAppSelector(selectShowStateModal);
  const { currentOrganization } = useAppSelector(selectOrganization);
  const organizationPrices = useAppSelector(selectOrganizationPrices);
  const currentState = useAppSelector(selectCurrentPatientState);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const routeCaseType = searchParams.get('case_type');
  const routeCurrentUserId = searchParams.get('current_user_id');
  const { state } = useLocation();
  // A linked (multi-stage) case still waiting on the patient (CaseStatus
  // upcoming) is completed by routing the patient through this same wizard
  // rather than a separate page — form_question_id 20 (case type) is
  // pre-dispatched by the caller (e.g. Sidenav's notification handler, or
  // completeLinkedCase.ts's startLinkedCaseCompletion) before navigating
  // here, so `caseType` below already resolves without ever visiting
  // /select-case-type. Lives in Redux rather than router state (see
  // linkedCaseSlice.ts) so it survives the "complete your profile first"
  // detour and a reload, unlike location.state.
  const { linkedCaseId, linkedCasePatientId } = useAppSelector(selectLinkedCase);
  const [isAvailableService, setIsAvailableService] = useState(false);
  const [openVerifyResultModal, setVerifyResultModal] = useState({
    isOpen: false,
    result: '',
  });
  const [submitCCConfirmation, setSubmitCCConfirmation] = useState(false);
  const caseType: string = !routeCaseType
    ? (values.find((item) => item.form_question_id === 20)?.value.caseType as string)
    : routeCaseType;
  const currentOrganizationPrice = organizationPrices?.currentOrganizationPrices?.find((price: Pricings) =>
    price.case_types.includes(caseType as string),
  );
  const [patientOptions, setPatientOptions] = useState<UserObject[]>([]);
  // Completing an existing linked case locks the picker to that case's own
  // patient — switching to a different family member here would complete
  // the wrong person's case. Filters rather than disables, reusing the
  // existing render path below.
  const visiblePatientOptions = useMemo(
    () =>
      linkedCasePatientId
        ? patientOptions.filter((option) => option.id === linkedCasePatientId.toString())
        : patientOptions,
    [patientOptions, linkedCasePatientId],
  );
  const lockedPatientName = linkedCasePatientId ? visiblePatientOptions[0]?.patientFullName : undefined;
  const [loading, setLoading] = useState(false);
  const [disableButton, setDisableButton] = useState(false);
  const { userInfo } = useAppSelector(selectAuth);
  const [hasFullProfile, setHasFullProfile] = useState(false);
  const [selectedPatientId, setSelectedPatientId] = useState<string>(
    state?.newDependentId?.toString() || state?.currentUserId?.toString() || routeCurrentUserId || '',
  );
  const getSelectedPatientLocationState = (): string =>
    currentState[userInfo.id] || getCurrentPState(userInfo.id) || '';
  const { videoCaseEnabled, asyncCaseEnabled } = useOrganizationFlags(getSelectedPatientLocationState());

  const isFromHandoffMobile = useAppSelector(selectIsFromHandOff);

  const completeMobileHandoffFn = async (): Promise<void> => {
    try {
      await completeMobileHandoff();
      dispatch(setIsFromHandoff(false));
    } catch (error: unknown) {
      displayErrorDetails(error);
    }
  };

  const [currentPatientState, setCurrentPatientState] = useState<string>(() => getSelectedPatientLocationState());

  const onCloseStateModal = (): void => {
    dispatch(setShowStateModal({ showStateModal: false }));
    setCurrentPatientState(getSelectedPatientLocationState());
  };

  const checkExternalForms = async (selectedPatientId: number): Promise<string[]> => {
    const [checkProfile, checkMedicalHistory, checkMedicalConditionsFormAnswer, checkDentalHistoryFormAnswer] =
      await checkExternalFormAnswers(
        userInfo,
        patientOptions.find((option) => option.id === selectedPatientId.toString())?.patient || null,
      );

    const formsToSet: string[] = [];

    if (!checkProfile) {
      formsToSet.push('patient_profile');
    }
    if (!checkMedicalHistory) {
      formsToSet.push('patient_medical_history');
    }
    if (!checkMedicalConditionsFormAnswer) {
      formsToSet.push('patient_medical_conditions');
    }
    if (!checkDentalHistoryFormAnswer) {
      formsToSet.push('patient_dental_history');
    }

    dispatch(setExternalForms(formsToSet));
    return formsToSet;
  };

  const fetchData = (selectedPatientId: number): Promise<string[]> => {
    return checkExternalForms(selectedPatientId);
  };

  const changeCurrentState = (selectedState: string): void => {
    if (
      ((currentOrganization as Organization).professional_corporations?.find(
        (professionalCorporation) => professionalCorporation.state === selectedState,
      )?.second_opinion_case_enabled &&
        caseType === CaseType.second_opinion) ||
      ((currentOrganization as Organization).professional_corporations?.find(
        (professionalCorporation) => professionalCorporation.state === selectedState,
      )?.video_case_enabled &&
        caseType === CaseType.video_call_scheduled) ||
      ((currentOrganization as Organization).professional_corporations?.find(
        (professionalCorporation) => professionalCorporation.state === selectedState,
      )?.async_case_enabled &&
        (caseType === CaseType.one_report ||
          caseType === CaseType.care_coordination ||
          caseType === CaseType.oral_health_coaching ||
          caseType === CaseType.clinical_enablement))
    ) {
      setCurrentPatientState(selectedState);
      setCurrentPatientLocationState(userInfo.id, selectedState);
      setValue('state', selectedState);
      dispatch(setPatientState({ userId: userInfo.id, state: selectedState }));
    } else if (selectedState !== '') {
      setIsAvailableService(true);
    }
  };

  const onInvalid = (errors: any): void => {
    const error = Object.values(errors)[0] as any;
    if (error) {
      toast.error(error.message as string);
    }
  };

  const { handleSubmit, setValue } = useForm<SelectPatientForm>({
    mode: 'onChange',
  });

  const goToDashboard = useCallback(() => {
    // This is a second exit point out of the wizard besides the header
    // X/logo (AbandonIntakeProcessModal, which already does this) — without
    // it, a patient who opens a "Complete Intake" notification and hits this
    // page's own Back button instead leaves linkedCaseId/linkedCasePatientId
    // stuck in Redux (not persist-blacklisted) to leak into whatever
    // unrelated case flow they start next.
    dispatch(clearLinkedCase());

    const params = new URLSearchParams(window.location.search);
    const redirectTo = params.get('return_to') || params.get('redirect_uri');

    if (redirectTo) {
      if (redirectTo.startsWith('/') && !redirectTo.startsWith('//')) {
        roleNavigate(redirectTo, { replace: true });
      } else {
        roleNavigate('/dashboard');
      }
    } else {
      roleNavigate('/dashboard');
    }
  }, [roleNavigate, dispatch]);

  const shouldWeContinue = (): boolean => {
    // const userInsurances = selectedPatient?.patientInsurance || [];
    // Read the location from the store, not the form's `state` field. The
    // field is only copied from the store in an effect after the render, and
    // setValue doesn't render again, so a state confirmed in StateModal once
    // the page had loaded (a patient arriving from the "Complete my intake"
    // email) left Next disabled even though the location was set.
    const state = getSelectedPatientLocationState();

    const isPatientSelected = selectedPatientId !== undefined && selectedPatientId !== '';
    const isCaseTypeVCOrOneReport =
      caseType === CaseType.video_call_scheduled ||
      caseType === CaseType.one_report ||
      caseType === CaseType.clinical_enablement;
    const isCaseTypeSecondOpinion = caseType === CaseType.second_opinion;

    const isStateValid = Boolean(state);

    // const isCoverageConditionMet = (userInsurances.length > 0 && coverageStatus === 'yes') || coverageStatus !== 'yes';

    if (!isPatientSelected) return false;
    if (caseType === CaseType.clinical_enablement && !asyncCaseEnabled) return false;

    if (isCaseTypeVCOrOneReport || isCaseTypeSecondOpinion) {
      if (!isStateValid) return false;
    }

    // if (isCaseTypeVCOrOneReport) {
    //   if (!isCoverageStatusValid || !isCoverageConditionMet) return false;
    // }

    return true;
  };

  const createCaseForThisRequirement = async (patientId: number, caseType: string): Promise<void> => {
    if (!currentOrganization?.id) {
      toast.error('Organization is missing. Please refresh and try again.');

      return;
    }

    const payload: CasePayload = {
      type: caseType,
      status: 'new',
      patient_id: Number(userInfo.id),
      organization_id: currentOrganization.id,
      provider_id: undefined,
      payment_profile_id: null,
      video_conference_date: null,
      patient_current_state: getSelectedPatientLocationState(),
      dependent_id: Number(userInfo.id) === Number(patientId) ? null : patientId,
      case_intake_questions: {
        is_dental_emergency: false,
        in_pain: false,
        pain_description: undefined,
        pain_time: undefined,
        pain_level: undefined,
        additional_info: '',
      },
    };
    const caseRes = await createNewCase(payload, userInfo.role.name);
    if (isFromHandoffMobile) {
      await completeMobileHandoffFn();
    }

    const imagesValue = values.find((item) => item.form_question_id === 17)?.value.images;
    if (Array.isArray(imagesValue)) {
      await uploadMediaToCase(caseRes, imagesValue, userInfo.role.name);
    }
    dispatch(setCaseId(caseRes.id.toString()));
    if (caseType === 'smile_scan') {
      let prefix = '';
      if (config.iot.prefix === 'develop') {
        prefix = 'dev-';
      } else if (config.iot.prefix === 'qa') {
        prefix = 'qa-';
      }
      const url = `https://selfcheck.toothlens.com/tpscan/done/${prefix}${caseRes.id}`;
      if (isMobile || mobileDetect) {
        window.location.href = url;
      } else {
        roleNavigate('/smile-scan-link', {
          state: {
            caseType,
            patientState: userInfo.address?.state,
            userOrganization: currentOrganization.id,
            patientId: userInfo.id,
          },
        });
      }
    } else {
      setSubmitCCConfirmation(!submitCCConfirmation);
    }
  };

  const onSubmit = async (selectedPatient: any): Promise<void> => {
    // The case records where the patient is, and that value is written once
    // and never revised. Detection runs in the background and may not have
    // landed (or may have come back empty), so confirm the location here
    // rather than letting the flow reach case creation with nothing — which
    // is how cases ended up filed under a state the patient was never in.
    // Provider flows are already gated implicitly: with no state, no licensed
    // provider matches and there is nothing to book. Care advisors aren't
    // state-licensed, so their scheduling never blocked and this is the only
    // thing standing between an unknown location and a mislocated case.
    const confirmedLocationState = getSelectedPatientLocationState();
    if (!confirmedLocationState) {
      dispatch(setShowStateModal({ showStateModal: true }));
      return;
    }

    if (caseType === CaseType.clinical_enablement && !asyncCaseEnabled) {
      setIsAvailableService(true);
      return;
    }

    // This check accepts the browser-stored copy, but the payment step that
    // finally builds the case reads the location from Redux alone. Each tab
    // keeps its own in-memory store and never sees another tab's writes, while
    // the stored copy is shared, so the two disagree whenever the location was
    // confirmed somewhere else — the check passes and the case is still created
    // with nothing. Put the value into Redux so what satisfied this check is
    // what the rest of the flow reads.
    if (!currentState[userInfo.id]) {
      dispatch(setPatientState({ userId: userInfo.id, state: confirmedLocationState }));
    }

    if (selectedPatient.id === undefined) {
      const foundPatient = patientOptions.find((p) => p.id === selectedPatientId);

      if (foundPatient) {
        selectedPatient = {
          selected_patient: {
            id: foundPatient.id,
            patientFullName: foundPatient.patientFullName,
            patient: foundPatient.patient,
          },
        };

        setValue('selected_patient', selectedPatient, { shouldValidate: true });
      }
    }
    if (selectedPatient?.selected_patient?.patientFullName === 'Myself') {
      dispatch(setIsFromSelectPatient(true));
      dispatch(setDependentId(null));
      roleNavigate('/create-your-profile', {
        state: { caseType },
      });
    } else if (selectedPatient?.selected_patient?.patientFullName === 'A Dependent') {
      dispatch(setIsFromSelectPatient(true));
      dispatch(setDependentId('1'));
      roleNavigate('/create-your-profile', {
        state: { caseType },
      });
    } else {
      dispatch(
        setSelectedPatient({
          value:
            userInfo.id === selectedPatient?.selected_patient?.patient?.id
              ? userInfo.id
              : selectedPatient?.selected_patient?.patient?.id,
          label:
            userInfo.id === selectedPatient?.selected_patient?.patient?.id
              ? userInfo.full_name
              : selectedPatient?.selected_patient?.patientFullName,
        }),
      );
      dispatch(setSelectedPatientByAdmin({ selectedPatient: selectedPatient?.selected_patient?.patient }));

      const data = await fetchData(Number(selectedPatient?.selected_patient?.id));
      if (selectedPatient?.selected_patient?.id) {
        if (data.length !== 0 && data.includes('patient_profile')) {
          dispatch(setIsFromSelectPatient(true));
          dispatch(
            setDependentId(
              userInfo.id === selectedPatient?.selected_patient?.patient?.id
                ? null
                : (selectedPatient?.selected_patient?.patient?.id?.toString() as string),
            ),
          );
          return roleNavigate('/my-profile', {
            state: {
              caseType,
              ...(!(userInfo.id === selectedPatient?.selected_patient?.patient?.id) && { openDependentProfile: true }),
              ...(userInfo.id === selectedPatient?.selected_patient?.patient?.id && { needToCompleteProfile: true }),
              ...(!(userInfo.id === selectedPatient?.selected_patient?.patient?.id) && {
                selectedDependentId: selectedPatient?.selected_patient?.id,
              }),
            },
          });
        }
      }

      if (isFromSmileScanReport) {
        return roleNavigate('/select-case-type', {
          state: {
            caseType,
            patientState: userInfo.address?.state,
            userOrganization: currentOrganization?.id,
            patientId: userInfo.id,
            selectedPatient,
          },
        });
      }

      if (caseType === 'video_call_scheduled') {
        roleNavigate('/select-provider', {
          state: {
            caseType: 'video_call_scheduled',
            insuranceCarrierId: '',
            customInsuranceCarrier: '',
            userOrganization: currentOrganization.id,
            patientId: userInfo.id,
          },
        });
      } else if (caseType === CaseType.phone_call_scheduled) {
        roleNavigate('/select-provider', {
          state: {
            caseType: CaseType.phone_call_scheduled,
            insuranceCarrierId: '',
            customInsuranceCarrier: '',
            userOrganization: currentOrganization.id,
            patientId: userInfo.id,
          },
        });
      } else if (caseType === CaseType.oral_health_coaching) {
        roleNavigate('/select-care-advisor', {
          state: {
            caseType: CaseType.oral_health_coaching,
            insuranceCarrierId: '',
            customInsuranceCarrier: '',
            userOrganization: currentOrganization.id,
            patientId: userInfo.id,
          },
        });
      } else if (
        isFree(currentOrganizationPrice) &&
        caseType === 'second_opinion' &&
        currentOrganizationPrice?.payment_options.length === 0
      ) {
        roleNavigate('/clinical-data', {
          state: {
            caseType,
            patientState: userInfo.address?.state,
            userOrganization: currentOrganization.id,
            patientId: userInfo.id,
          },
        });
      } else if (caseType === CaseType.care_coordination) {
        // Per the original CC intake spec, the only patient-side steps
        // are: select patient → profile (collected above when missing)
        // → payment info (skipped only when truly free). The
        // medical / dental clinical-data questionnaire is not part of
        // CC, even for a brand-new user whose first case is CC. Without
        // this explicit branch the catch-all `else` below sent CC into
        // /clinical-data whenever the price was anything other than
        // exactly free + zero payment options — which produced the
        // medical-conditions page Enes reported.
        if (!needsPayment(currentOrganizationPrice) && !linkedCaseId) {
          createCaseForThisRequirement(selectedPatient?.selected_patient?.patient?.id || 0, CaseType.care_coordination);
        } else {
          // A linked CC case landed in `upcoming` in the first place because
          // it needs the patient's action, so it always has something left
          // to collect here even if the org's pricing looks free-with-no-
          // options in the abstract — never take the auto-create shortcut
          // above for one. linkedCaseId itself doesn't need forwarding here —
          // it's read straight from Redux (linkedCaseSlice) downstream.
          roleNavigate('/payment-information', { state: { caseType } });
        }
      } else if (caseType === 'smile_scan') {
        createCaseForThisRequirement(selectedPatient?.selected_patient?.patient?.id || 0, CaseType.smile_scan);
      } else if (caseType === CaseType.clinical_enablement) {
        // Photos come before the medical-history questionnaire for this case
        // type only, so those steps can tell whether a file was already
        // attached and relax their required fields accordingly.
        roleNavigate('/upload-image', {
          state: {
            caseType,
            patientState: userInfo.address?.state,
            userOrganization: currentOrganization.id,
            patientId: userInfo.id,
          },
        });
      } else {
        roleNavigate('/clinical-data', {
          state: {
            caseType,
            patientState: userInfo.address?.state,
            userOrganization: currentOrganization.id,
            patientId: userInfo.id,
          },
        });
      }
    }
    setDisableButton(false);
  };
  useEffect(() => {
    dispatch(setIsFromSelectPatient(false));
    dispatch(setDependentId(null));
  }, [dispatch]);

  useEffect(() => {
    if (state?.newDependentId) {
      const currentUser = patientOptions.find((option) => option.id === state.newDependentId);
      setValue('selected_patient', currentUser as UserObject, { shouldValidate: true });
      setSelectedPatientId(state?.newDependentId.toString() || '');
    } else if (state?.currentUserId) {
      const currentUser = patientOptions.find((option) => option.id === state.currentUserId);
      setValue('selected_patient', currentUser as UserObject, { shouldValidate: true });
      setSelectedPatientId(state?.currentUserId.toString() || '');
    } else if (routeCurrentUserId) {
      const currentUser = patientOptions.find((option) => option.id === routeCurrentUserId);
      setValue('selected_patient', currentUser as UserObject, { shouldValidate: true });
      setSelectedPatientId(routeCurrentUserId.toString() || '');
    } else if (patientOptions.length > 0) {
      setValue('selected_patient', patientOptions[0], { shouldValidate: true });
      setSelectedPatientId(patientOptions[0].id || '');
    }
  }, [state?.newDependentId, state?.currentUserId, routeCurrentUserId, patientOptions, setValue]);

  useEffect(() => {
    (async () => {
      dispatch(clearPageState());

      if (routeCaseType) {
        const formPayload: FormValues[] = [
          {
            form_question_id: 20,
            value: {
              caseType: 'video_call_scheduled',
            },
          },
        ];

        dispatch(setForm(formPayload));
      }

      await fetchUserInfo();

      const handleVisibilityChange = (): void => {
        if (document.visibilityState === 'visible' && caseType === CaseType.smile_scan) {
          window.location.reload();
        }
      };

      const getPricingsFn = async (): Promise<void> => {
        setLoading(true);
        try {
          const pricings = await getPricings();
          dispatch(setOrganizationPrices({ currentOrganizationPrices: pricings }));
        } catch (error: unknown) {
          displayErrorDetails(error);
        }
        setLoading(false);
      };

      if (!organizationPrices?.currentOrganizationPrices) {
        await getPricingsFn();
      }

      document.addEventListener('visibilitychange', handleVisibilityChange);

      return () => {
        document.removeEventListener('visibilitychange', handleVisibilityChange);
      };
    })();
  }, []);

  useEffect(() => {
    fetchUserInfo();
  }, [deactivateInsuranceById]);

  useEffect(() => {
    if (currentState[userInfo.id]) setValue('state', currentState[userInfo.id], { shouldValidate: true });
  }, [currentState[userInfo.id]]);

  const fetchUserInfo = async (): Promise<void> => {
    try {
      setLoading(true);
      const [, , , , checkEssentialProfileFormAnswer] = await checkExternalFormAnswers(userInfo, null);
      setHasFullProfile(checkEssentialProfileFormAnswer);

      if (checkEssentialProfileFormAnswer) {
        const listOfDependents = await listDependents(userInfo.id, { include_deleted: false });
        const insurancePromises = listOfDependents.map(async (dependent) => {
          // const insurance = caseType !== CaseType.smile_scan ? await getPatientInsurance(dependent.id) : [];

          return {
            patient: dependent,
            patientFullName: dependent.full_name,
            // patientInsurance: insurance,
            id: dependent.id?.toString(),
          };
        });

        const dependentUserObjects = await Promise.all(insurancePromises);

        // const userInsurance = caseType !== CaseType.smile_scan ? await getPatientInsurance() : [];

        const options = [
          {
            patient: userInfo,
            patientFullName: userInfo.full_name,
            // patientInsurance: userInsurance,
            id: userInfo.id?.toString(),
          },
          ...dependentUserObjects,
        ];

        setPatientOptions(options);
      } else {
        // DO-4007 reopen: previously this fallback hardcoded both
        // "Myself" and "A Dependent" regardless of whether the user
        // actually had any dependents. Reporter saw the option appear
        // for a self-serve patient with zero dependents (and for an
        // admin who landed here via a Cancel back-nav from the case-
        // creation flow). Mirror the happy path: ask the API whether
        // the user has any dependents and only show the entry when
        // they do. We still hardcode the labels here (vs. resolving
        // each dependent's full_name) because at this branch the user
        // hasn't filled out their own basic_info yet, so dependent
        // records are typically just shells with no name to render.
        const fallbackDependents = await listDependents(userInfo.id, { include_deleted: false });
        const hasDependents = fallbackDependents.length > 0;
        setPatientOptions([
          {
            patient: null,
            patientFullName: 'Myself',
            // patientInsurance: null,
            id: userInfo.id?.toString(),
          },
          ...(hasDependents
            ? [
                {
                  patient: null,
                  patientFullName: 'A Dependent',
                  // patientInsurance: null,
                  id: '0',
                },
              ]
            : []),
        ]);
      }
      setLoading(false);
    } catch (error: unknown) {
      displayErrorDetails(error);
    }
  };

  const initializeComponent = (): void => {
    window.location.reload();
  };

  const handleVisibilityChange = (): void => {
    if (document.visibilityState === 'visible' && caseType === CaseType.smile_scan) {
      initializeComponent();
    }
  };
  document.addEventListener('visibilitychange', handleVisibilityChange);
  // An empty locationState means detection hasn't resolved yet (denied, timed out, or still
  // in flight) — that's "unknown," not "unavailable here." Only declare the service
  // unavailable once we actually have a state to check; otherwise fall through to the form
  // below, which prompts the patient to select their state (inline selector / StateModal).
  const locationState = getSelectedPatientLocationState();
  return (locationState &&
    !videoCaseEnabled &&
    (caseType === 'video_call_scheduled' || caseType === CaseType.phone_call_scheduled)) ||
    (caseType === undefined && !isFromSmileScanReport) ? (
    <NoServiceAvailableModal isOpen hideModal={setIsAvailableService} />
  ) : (
    <Container
      isVisibleOnMobile
      containerStyle={{
        justifyContent: screenSize.width >= 564 ? 'center' : 'start',
        overflow: 'hidden',
      }}
      childrenStyle={{ zIndex: '2', paddingTop: screenSize.width > 768 ? '40px' : '16px' }}
      isSidenavVisible={false}
      isIntakeProcess
    >
      <div className={`fs-unmask ${styles.patientFormContainer}`}>
        <PatientIntakeNavigation progress={4} />
        <form className={`${styles.formContainer}`} onSubmit={handleSubmit(onSubmit, onInvalid)}>
          <div className={styles.patientSelectDiv}>
            <div className={styles.patientSelectContainer}>
              <span className={styles.patientSelectSpan}>
                Who is the appointment for? <span className={styles.patientSelectSpanRequired}>*</span>
              </span>
              {lockedPatientName && (
                <span className={`fs-unmask ${styles.patientSelectSpan}`} style={{ fontWeight: 400 }}>
                  Completing an existing case for {lockedPatientName}
                </span>
              )}
              {!loading ? (
                visiblePatientOptions.map((element) => (
                  <Fragment key={element.id}>
                    <input
                      type="radio"
                      className="d-none fs-unmask"
                      value={element.id as string}
                      id={element.id as string}
                      onClick={() => {
                        setValue('selected_patient', element, { shouldValidate: true });
                        setSelectedPatientId(element.id as string);
                      }}
                      data-testid="select-patient-input"
                    />
                    <div data-testid="select-patient-div">
                      <label
                        className={`${styles.mobileLabel} ${
                          selectedPatientId === element.id ? styles.selectedClass : styles.btn
                        }`}
                        htmlFor={element.id || ''}
                        data-testid="select-patient-div-label"
                      >
                        <div className={styles.labelWrap}>
                          <img
                            alt="Avatar"
                            onError={(event: any) => {
                              const img = event.target;
                              img.src =
                                'https://media.istockphoto.com/id/1130884625/tr/vekt%C3%B6r/kullan%C4%B1c%C4%B1-%C3%BCyesi-vekt%C3%B6r-simgesi-ui-kullan%C4%B1c%C4%B1-arabirimi-veya-profil-face-avatar-uygulamas%C4%B1.jpg?s=612x612&w=0&k=20&c=jAf5nq1ebnZo8TJbjaB9dMHMvgff7uOk67NkF5CpgB0=';
                              img.onError = null;
                            }}
                            className={`fs-exclude ${styles.patientImage}`}
                            src={getUserAvatar(Number(element.id))}
                          />
                          <span className={`fs-exclude ${styles.patientName}`}>{element.patientFullName}</span>
                        </div>
                        <div
                          className={`${styles.bntIcon} ${selectedPatientId === element.id ? styles.primaryColor : ''}`}
                        />
                      </label>
                    </div>
                  </Fragment>
                ))
              ) : (
                <span>
                  <Loading dotted />
                </span>
              )}
              {hasFullProfile && !lockedPatientName && (
                <Button
                  className={`fs-unmask ${styles.addBtn}`}
                  type="button"
                  variant="text"
                  data-testid="select-patient-add-dependent"
                  onClick={() => {
                    dispatch(setIsFromSelectPatient(true));
                    dispatch(setDependentId('0'));
                    roleNavigate('/add-dependent', {
                      state: {
                        caseType,
                      },
                    });
                  }}
                >
                  <AddIcon className={styles.addIcon} />
                  Add Dependent
                </Button>
              )}
            </div>
            {(caseType === CaseType.video_call_scheduled ||
              caseType === CaseType.one_report ||
              caseType === CaseType.second_opinion ||
              caseType === CaseType.clinical_enablement) && (
              <div className={styles.patientStateDuringConsultation}>
                <span className={styles.patientSelectSpan}>
                  Where will you be during the appointment? <span className={styles.patientSelectSpanRequired}>*</span>
                </span>
                <span className={styles.patientSelectSubSpan}>
                  You can only complete an appointment with providers licensed in the location that you choose here.
                </span>
                <div className={styles.patientSelectInput}>
                  <MUISelectInput
                    data-testid="complete-profile-state"
                    label="Select state"
                    name="state"
                    onChange={(e: any) => changeCurrentState(e)}
                    value={currentState[userInfo.id] ?? currentPatientState}
                    required
                    inputClass={`${styles.patientInputClass} fs-exclude`}
                    wrapperClassName={`fs-unmask ${styles.completeProfileClass}`}
                    options={stateOptionsWithoutAbbreviation}
                  />
                  {caseType === CaseType.clinical_enablement && locationState && !asyncCaseEnabled && (
                    <p role="alert">Clinical Enablement is not available in this state. Please verify your location.</p>
                  )}
                </div>
              </div>
            )}
            {/*             {(caseType === CaseType.video_call_scheduled || caseType === CaseType.one_report) && (
              <>
                {' '}
                <div className={styles.patientInsuranceCoverageSection}>
                  <span className={styles.patientSelectSpan}>
                    Do you currently have insurance coverage through a state-funded program such as Medicaid?{' '}
                    <span className={styles.patientSelectSpanRequired}>*</span>
                  </span>
                  <MuiToggle
                    label="State-funded coverage"
                    hideLabel
                    options={[
                      { value: 'yes', label: 'Yes' },
                      { value: 'no', label: 'No' },
                      { value: 'not_sure', label: 'Not Sure' },
                    ]}
                    selectedValue={getValues('state_funded_coverage_status') as string}
                    onChange={(value: string) =>
                      setValue('state_funded_coverage_status', value, { shouldValidate: true })
                    }
                  />
                </div>
                {getValues('state_funded_coverage_status') !== undefined &&
                  getValues('selected_patient')?.id !== undefined && (
                    <div className={styles.patientInsuranceSection}>
                      <span className={styles.patientSelectSpan}>
                        Add your insurance{' '}
                        {getValues('state_funded_coverage_status') === 'yes' ? (
                          <span className={styles.patientSelectSpanRequired}>*</span>
                        ) : (
                          '(optional)'
                        )}
                      </span>
                      <span className={styles.patientSelectSubSpan}>
                        Providing your insurance details helps us find in-network providers for you and verify your
                        coverage so we can submit claims to your insurance provider. Please note that coverage is not
                        guaranteed.
                      </span>
                      {patientOptions
                        .find((patientOption) => patientOption.id === getValues('selected_patient')?.id)
                        ?.patientInsurance?.filter((insurance) => insurance.is_current)
                        .map((selectedPatientInsurance, index) => (
                          <div className={styles.insuranceDivContainer} key={index}>
                            <div className={styles.insuranceDivContainerLeft}>
                              <span className={styles.insuranceDivContainerPrimary}>
                                {index === 0 ? 'Primary insurance' : 'Secondary insurance'}
                              </span>
                              <span className={styles.insuranceDivContainerName}>
                                {selectedPatientInsurance.insurance_membership?.insurance_carrier?.name}
                              </span>
                              <span className={styles.insuranceDivContainerMemberId}>
                                {selectedPatientInsurance.insurance_membership?.member_id}
                              </span>
                              <span
                                className={styles.removeInsurance}
                                onClick={() => deactivateThisInsurance(selectedPatientInsurance.id || 0)}
                              >
                                Remove insurance
                              </span>
                            </div>
                            <div className={styles.insuranceDivContainerRight}>
                              <span
                                onClick={() =>
                                  setEditInsurance({
                                    isOpen: true,
                                    insuranceId: Number(selectedPatientInsurance.id),
                                  })
                                }
                              >
                                Edit
                              </span>
                            </div>
                          </div>
                        ))}
                      {hasOneInsurance && (
                        <button
                          type="button"
                          className={styles.addSecondaryInsuranceButton}
                          onClick={() =>
                            setEditInsurance({
                              isOpen: true,
                              insuranceId: 0,
                            })
                          }
                        >
                          <FiPlus className={styles.addIcon} />
                          Add Secondary Insurance
                        </button>
                      )}
                      {hasNoInsurance && (
                        <button
                          type="button"
                          className={styles.addSecondaryInsuranceButton}
                          onClick={() =>
                            setEditInsurance({
                              isOpen: true,
                              insuranceId: 0,
                            })
                          }
                        >
                          <FiPlus className={styles.addIcon} />
                          Add Insurance
                        </button>
                      )}
                    </div>
                  )}
              </>
            )} */}
            <div className={styles.patientSelectFooter}>
              <Button
                variant="text"
                data-testid="select-patient-back-button"
                className={styles.patientSelectFooterBack}
                onClick={goToDashboard}
              >
                <ArrowBackIosNewIcon />
                Back
              </Button>
              <Button
                variant="contained"
                className={styles.patientSelectFooterNext}
                data-testid="select-patient-next-button"
                type="submit"
                disabled={!shouldWeContinue() || loading || disableButton}
              >
                Next
              </Button>
            </div>
          </div>
        </form>
        {/*         {isEditInsurance.isOpen && (
          <InsuranceModal
            isOpen={isEditInsurance.isOpen}
            toggleModal={setEditInsurance}
            setLoading={setLoading}
            loading={loading}
            hideModal={() =>
              setEditInsurance({
                isOpen: false,
                insuranceId: 0,
              })
            }
            userInsurance={(() => {
              const selectedPatient = patientOptions.find(
                (patientOption) => patientOption.id === getValues('selected_patient')?.id,
              );
              const selectedInsurance = selectedPatient?.patientInsurance?.find(
                (insurance) => insurance.id === isEditInsurance.insuranceId,
              );
              return selectedInsurance ? [selectedInsurance] : [];
            })()}
            userInsurances={
              patientOptions
                .find((patientOption) => patientOption.id === getValues('selected_patient')?.id)
                ?.patientInsurance?.filter((insurance) => insurance.is_current) || []
            }
            patientOptions={patientOptions}
            selectedPatientId={getValues('selected_patient')?.id || ''}
            setPatientOptions={setPatientOptions}
            showSnackbar={showSnackbar}
            stateFundedCoverageStatus={getValues('state_funded_coverage_status')}
            setVerifyResultModal={setVerifyResultModal}
          />
        )} */}
      </div>
      <GenericSnackbar open={snackbar.isOpen} message={snackbar.message} type={snackbar.type} onClose={closeSnackbar} />
      <NoServiceAvailableModal isOpen={isAvailableService} hideModal={setIsAvailableService} />
      <InsuranceVerifyModal
        isOpen={openVerifyResultModal.isOpen}
        hideModal={setVerifyResultModal}
        verifyResult={openVerifyResultModal.result}
      />
      <StateModal isOpen={showStateModal} onClose={onCloseStateModal} />
      {submitCCConfirmation && <SubmitCCConfirmationModal />}
    </Container>
  );
};
export default SelectPatient;
